import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileQuestion, Home, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="max-w-md w-full border bg-background">
        <CardHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <div className="p-4 bg-muted rounded-full">
              <FileQuestion className="h-12 w-12 text-muted-foreground" />
            </div>
          </div>
          <CardTitle className="text-3xl font-bold text-primary">
            Seite nicht gefunden
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="text-center space-y-2">
            <p className="text-6xl font-bold text-muted-foreground">404</p>
            <p className="text-sm text-muted-foreground">
              Die angeforderte Seite konnte nicht gefunden werden.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <Button onClick={() => void navigate("/")} className="w-full">
              <Home className="h-4 w-4 mr-2" />
              Zur Startseite
            </Button>
            <Button
              onClick={() => void navigate(-1)}
              variant="outline"
              className="w-full"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Zurück
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
